"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _index = require("../../../../material/index");

var _debounce = require("../../../../utils/debounce");

var _dropdownitem = _interopRequireDefault(require("./dropdownitem/dropdownitem"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _singleselect_styles = _interopRequireDefault(require("./singleselect_styles"));

var _singleselect_definition = _interopRequireDefault(require("./singleselect_definition"));

var _definecomponent = require("../../../../utils/definecomponent");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/* ========== ~~~~~~~~~~ EXPORT : DROPDOWN : SINGLE SELECT ~~~~~~~~~~ ========== */


var SingleSelectDropDown =
/*#__PURE__*/
function (_Component) {
  _inherits(SingleSelectDropDown, _Component);

  function SingleSelectDropDown(props) {
    var _this;

    _classCallCheck(this, SingleSelectDropDown);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SingleSelectDropDown).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleOutsideClick", function (e) {
      // ignore clicks on the component itself
      if (_this.node.contains(e.target)) {
        return;
      }

      _this.hideMenu();
    });

    _defineProperty(_assertThisInitialized(_this), "showMenu", function () {
      _this.props.searchable !== false && _this.node.querySelector('input').focus();

      _this.setState({
        active: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "hideMenu", function () {
      return _this.setState({
        active: false,
        searchTerm: '',
        items: _this.props.items,
        paginationPosition: 0
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleClick", function () {
      return _this.state.active ? _this.hideMenu() : _this.showMenu();
    });

    _defineProperty(_assertThisInitialized(_this), "renderItems", function () {
      var items = JSON.parse(JSON.stringify(_this.state.items));

      if (_this.props.paginated) {
        items = items.slice(_this.state.paginationPosition, _this.state.paginationPosition + _this.props.itemsPerPage);
      }

      return items.map(function (item, i) {
        return _react.default.createElement(_dropdownitem.default, {
          handleSelect: _this.handleSelect,
          searchTerm: _this.state.searchTerm,
          name: item.name,
          value: item.value,
          itemSelected: _this.state.items[i].value === item.value,
          key: i,
          index: i,
          item: item
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderPagination", function () {
      if (!!_this.props.paginated && _this.state.items.length > _this.props.itemsPerPage) {
        return _react.default.createElement(_index.StandardPagination, {
          currentIndex: _this.state.paginationPosition + _this.props.itemsPerPage,
          itemsPerPage: _this.props.itemsPerPage,
          totalItems: _this.state.items.length,
          firstLastButtons: false,
          handlePrevious: function handlePrevious(e) {
            return _this.setState({
              paginationPosition: _this.state.paginationPosition - _this.props.itemsPerPage
            });
          },
          handleNext: function handleNext(e) {
            return _this.setState({
              paginationPosition: _this.state.paginationPosition + _this.props.itemsPerPage
            });
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleSelect", function (item) {
      _this.setState({
        selected: item.name,
        active: false,
        searchTerm: '',
        items: _this.props.items
      });

      _this.props.onSelect(item);
    });

    _defineProperty(_assertThisInitialized(_this), "handleSearch", function (keywords) {
      var items = _this.props.items.filter(function (item) {
        return item.name.toLowerCase().indexOf(keywords.toLowerCase()) !== -1;
      });

      _this.setState({
        items: items,
        searchTerm: keywords,
        paginationPosition: 0
      });
    });

    _this.state = {
      active: false,
      selected: '',
      searchTerm: '',
      paginationPosition: 0,
      items: _this.props.items
    };
    return _this;
  }

  _createClass(SingleSelectDropDown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      return document.addEventListener('mousedown', this.handleOutsideClick, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      return document.removeEventListener('mousedown', this.handleOutsideClick, false);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.items.length !== this.props.items.length) {
        this.setState({
          items: this.props.items
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var name = this.props.name;
      var active = this.state.active;
      return _react.default.createElement("div", {
        className: "searchabledropdown singleselectdropdown dropdown ".concat(this.props.classes.singleselectdropdown, " ").concat(this.props.klass, " disabled-").concat(this.props.disabled, " name-").concat(name),
        ref: function ref(node) {
          _this2.node = node;
        }
      }, _react.default.createElement("div", {
        className: "placeholder active-".concat(active),
        onClick: this.handleClick
      }, _react.default.createElement("span", {
        className: 'placeholdertext'
      }, this.props.selected ? this.props.selected.name : this.props.name), _react.default.createElement(_index.Icon, {
        name: "sort-down"
      })), _react.default.createElement(_index.Group, {
        name: "menuItems active-".concat(active)
      }, this.props.searchable !== false && _react.default.createElement(_index.SearchBar, {
        forwardedRef: this.searchFieldRef,
        value: this.state.searchTerm,
        placeholder: name,
        onChange: function onChange(keyword) {
          return (0, _debounce.debounce)(_this2.handleSearch(keyword), 300);
        }
      }), _react.default.createElement(_index.Group, {
        name: "items"
      }, this.renderItems(), this.renderPagination())));
    }
  }]);

  return SingleSelectDropDown;
}(_react.Component);
/* ========== ~~~~~~~~~~ DEFINE COMPONENT ~~~~~~~~~~ ========== */


(0, _definecomponent.defineComponent)(SingleSelectDropDown, _singleselect_definition.default, false);
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

var _default = (0, _reactJss.default)(_singleselect_styles.default)(SingleSelectDropDown);

exports.default = _default;